import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/components/sections/CodeShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/components/sections/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/components/sections/hero/Home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/components/sections/ProcessSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/components/sections/SkillsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ericmalek/Desktop/Portfolio/ej-claude/ejclaude/components/sections/WorkSection.tsx");
